/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconToolTipFilled from '@telus-uds/palette-koodo/build/rn/icons/ToolTipFilled'
import PaletteIconTooltip from '@telus-uds/palette-koodo/build/rn/icons/Tooltip'
import PaletteIconCheckCircledFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircledFilled'
import PaletteIconExclamationTriangle from '@telus-uds/palette-koodo/build/rn/icons/ExclamationTriangle'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
import PaletteIconTagFilled from '@telus-uds/palette-koodo/build/rn/icons/TagFilled'
const theme = {
  appearances: {
    inverse: {
      description: 'Inverts the status colors',
      type: 'variant',
      values: [ true ]
    },
    priority: { type: 'variant', values: [ 'default', 'low', 'high' ] },
    purpose: {
      type: 'variant',
      values: [
        'default', 'brand',
        'subtle',  'success',
        'warning', 'error',
        'offer'
      ]
    }
  },
  rules: [
    { if: { purpose: 'brand' }, tokens: { iconColor: '#000000' } },
    {
      if: { purpose: 'subtle' },
      tokens: { icon: PaletteIconTooltip }
    },
    {
      if: { purpose: 'success' },
      tokens: { icon: PaletteIconCheckCircledFilled, iconColor: '#1c7b2b' }
    },
    {
      if: { purpose: 'warning' },
      tokens: { icon: PaletteIconExclamationTriangle, iconColor: '#c9370b' }
    },
    {
      if: { purpose: 'error' },
      tokens: { icon: PaletteIconExclamationOctagon, iconColor: '#c9370b' }
    },
    {
      if: { purpose: 'offer' },
      tokens: { icon: PaletteIconTagFilled, iconColor: '#7a3dfc' }
    },
    {
      if: { priority: 'low' },
      tokens: {
        borderRadius: 99,
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4
      }
    },
    {
      if: { priority: 'high' },
      tokens: {
        backgroundColor: '#000000',
        borderRadius: 99,
        iconColor: '#ffffff',
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4,
        textColor: '#ffffff'
      }
    },
    {
      if: { priority: 'low', purpose: 'default' },
      tokens: { backgroundColor: '#efefef' }
    },
    {
      if: { priority: 'high', purpose: 'default' },
      tokens: { backgroundColor: '#000000' }
    },
    {
      if: { priority: 'low', purpose: 'brand' },
      tokens: { backgroundColor: '#efefef' }
    },
    {
      if: { priority: 'high', purpose: 'brand' },
      tokens: { backgroundColor: '#000000' }
    },
    {
      if: { priority: 'low', purpose: 'subtle' },
      tokens: { backgroundColor: '#efefef' }
    },
    {
      if: { priority: 'high', purpose: 'subtle' },
      tokens: {
        backgroundColor: '#c9c8c8',
        iconColor: '#000000',
        textColor: '#000000'
      }
    },
    {
      if: { priority: 'low', purpose: 'success' },
      tokens: { backgroundColor: '#c5f2cc' }
    },
    {
      if: { priority: 'high', purpose: 'success' },
      tokens: { backgroundColor: '#1c7b2b' }
    },
    {
      if: { priority: 'low', purpose: 'warning' },
      tokens: { backgroundColor: '#fff5d2' }
    },
    {
      if: { priority: 'high', purpose: 'warning' },
      tokens: { backgroundColor: '#c9370b' }
    },
    {
      if: { priority: 'low', purpose: 'error' },
      tokens: { backgroundColor: '#fcd3c6' }
    },
    {
      if: { priority: 'high', purpose: 'error' },
      tokens: { backgroundColor: '#c9370b' }
    },
    {
      if: { priority: 'low', purpose: 'offer' },
      tokens: { backgroundColor: '#e0d8fc' }
    },
    {
      if: { priority: 'high', purpose: 'offer' },
      tokens: { backgroundColor: '#7a3dfc' }
    },
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: '#ffffff',
        textColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, priority: 'low' },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)' }
    },
    {
      if: { inverse: true, priority: 'high' },
      tokens: {
        backgroundColor: '#ffffff',
        iconColor: '#000000',
        textColor: '#000000'
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    backgroundGradient: null,
    borderColor: null,
    borderRadius: null,
    borderWidth: null,
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    icon: PaletteIconToolTipFilled,
    iconColor: '#000000',
    iconGradient: null,
    iconPaddingTop: 0,
    iconSize: 20,
    marginLeft: 8,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    textColor: '#000000',
    textLineHeight: 1.14285714286
  }
}
export default theme
